<template>
  <v-container fluid py-2>
    <div class="chats-edit">
    <v-select
        v-if="userId && Object.keys(remotechats).length"
        :items="['Local', 'Remote']"
        v-model="chatType"
        v-on:change="onChangeSceneType()"
    >
    </v-select>
      <v-list>
        <div style="padding: 50px;" class="text-xs-center" v-if="Object.keys(displayScenes).length==0">
          <div v-if="initialized">
            <p>No scenes yet.</p>
            <p>Click
              <v-fab-transition >
                <v-btn
                dark
                fab
                small
                color="pink"
                v-on:click="onAddContent()"
                >
                <v-icon >add</v-icon>
              </v-btn>
              </v-fab-transition>
               to add one, or check out our samples <a href="#/play/VyB4gYHkoVnSX8VG6w1h">here</a></p>
          </div>
          <div v-else>
            <p>Loading...</p>
          </div>
        </div>
        <div
        v-on:click="onSelectIndex(index)"
        v-on:dblclick="onEditScene(index)"
        v-for="(scene, sceneId, index) in displayScenes" :key="sceneId"
        >
        <v-card >
          <v-layout row wrap align-center v-bind:class="{ 'elevation-24': index===selectedIndex }">
            <v-flex xs5 sm6 >
              <v-container fluid>
                <v-layout row wrap>
                  <v-flex v-for="facethumb in uniqueFaceThumbsForScene(sceneId)" v-bind:key="facethumb" xs6 sm4 lg3>
                    <v-card flat tile>
                      <v-img
                      contain
                      v-bind:src="facethumb"
                      height="50px"
                      >
                    </v-img>
                  </v-card>
                </v-flex>
              </v-layout>
            </v-container>
          </v-flex>
          <v-flex xs7 sm6>
            <strong>
            {{scene.title}}
            </strong>
          </v-flex>
          <v-scroll-y-transition hide-on-leave>
            <v-flex xs12  mb-3
            v-if="index===selectedIndex"
            >

            <v-layout justify-space-around >
              <v-btn fab small >
                <v-icon  v-on:click="onEditScene(sceneId)">create</v-icon>
              </v-btn>
              <v-btn fab small>
                <v-icon v-on:click="onPlayScene(sceneId)" >play_arrow</v-icon>
              </v-btn>
              <!--
              <v-btn fab small >
                <v-icon v-on:click="onDeleteScene(sceneId)" >delete</v-icon>
              </v-btn>
              -->
            </v-layout>
          </v-flex>
          </v-scroll-y-transition>
      </v-layout>
    </v-card>

    <v-divider></v-divider>
  </div>
</v-list>

<v-fab-transition >
  <v-btn
  absolute
  dark
  fab
  bottom
  right
  fixed
  color="pink"
  v-on:click="onAddContent()"
  style="bottom: 30px"
  >
  <v-icon>add</v-icon>
</v-btn>
</v-fab-transition>

</div>
</v-container>
</template>

<script>
import {SmoothFile} from 'smooth-script'
import Face from '../tts/face'
export default {

  data () {
    return {
      selectedIndex: null,
      displayScenes: {},
      chatType: 'Local',
      chatClass: SmoothFile
    }
  },
  computed: {
    chats () {
      var chats = {}
      var localChats = this.$store.getters['main/chats']
      for (var id in localChats) {
        if (!(id in this.$store.getters['main/remotechats']) && !(localChats[id].firestore && localChats[id].firestore.owner)) {
          chats[id] = localChats[id]
        }
      }
      return chats
    },
    remotechats () {
      return this.$store.getters['main/remotechats']
    },
    initialized () {
      return this.$store.getters['main/bInitialized']
    },
    faces () {
      return this.$store.getters['main/allfaces']
    },
    userId () {
      return this.$store.getters['main/userId']
    },
    defaultOptions () {
      return this.$store.getters['main/defaultOptions']
    }
  },
  methods: {
    onChangeSceneType: function () {
      var optionsCopy = JSON.parse(JSON.stringify(this.defaultOptions))
      if (this.chatType === 'Local') {
        this.displayScenes = this.chats
      } else {
        this.displayScenes = this.remotechats
      }
      optionsCopy.chatType = this.chatType
      this.$store.dispatch('main/updateDefaultOptions', optionsCopy)
    },
    onEditScene: function (sceneId) {
      this.$router.push({ path: `/edit/${sceneId}` })
    },
    onPlayScene: function (sceneId) {
      this.$router.push({ path: `/play/${sceneId}` })
    },
    onAddContent: function () {
      this.$store.dispatch('main/createContent', new SmoothFile())
        .then((id) => {
          this.$router.push({ path: `/edit/${id}` })
        })
    },
    onSelectIndex: function (index) {
      this.selectedIndex = index
    },
    onDeleteScene: function (id) {
      this.$store.dispatch('main/deleteChat', id).then(() => {
        // required to keep displayScenes reactive with chats
        this.onChangeSceneType()
      })
    },
    uniqueFaceThumbsForScene: function (id) {
      if (id in this.displayScenes && this.displayScenes[id].faces) {
        var unique = Object.keys(this.displayScenes[id].faces)
        var faceThumbs = {}
        for (var i = 0; i < unique.length; i++) {
          if (this.faces[unique[i]]) {
            faceThumbs[this.faces[unique[i]].thumb] = true
          } else {
            faceThumbs[Face.defaultThumb] = true
          }
        }
        var thumbs = Object.keys(faceThumbs)
        return thumbs
      }
      return []
    },
    onInitilized: function () {
      this.chatType = this.defaultOptions.chatType || 'Local'
      this.onChangeSceneType()
    }
  },
  created: function () {

  },
  mounted: function () {
    if (this.initialized) {
      this.onInitilized()
    }
  },
  watch: {
    initialized: function (newVal, oldVal) {
      if (newVal && !oldVal) {
        this.onInitilized()
      }
    }
  }
}

</script>



// WEBPACK FOOTER //
// src/components/ChatsView.vue